/**
 *
 * @author Atish Bagate
 */
interface Params {
  patientQuestionAnswerRequest: PatientQuestionAnswerRequest;
  xTENANTID?: string;
}

import {
  PatientQuestionAnswerRequest,
  PatientSocialHistoryControllerApi,
} from "../../../services";
import { getConfigObject, useMutationWithLoading } from "../../../utils/utils";

export const useUpdatePatientSocialHistory = () =>
  useMutationWithLoading(
    async ({ patientQuestionAnswerRequest, xTENANTID }: Params) =>
      new PatientSocialHistoryControllerApi(
        getConfigObject()
      ).updatePatientSocialHistory(patientQuestionAnswerRequest, xTENANTID)
  );
